import { render, staticRenderFns } from "./SectorTypeView.vue?vue&type=template&id=dde8b9d2&"
import script from "./SectorTypeView.vue?vue&type=script&lang=js&"
export * from "./SectorTypeView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports